export const FAQS = [
  {
    title: "How long does a typical migration take?",
    content:
      "Timelines vary by workload size and complexity, but most migrations are completed in 2–6 weeks. OneMind uses automated tooling and phased cutovers to accelerate timelines without compromising stability.",
  },
  {
    title: "Can we test workloads in Zadara before fully migrating?",
    content:
      "Yes. We support pilot migrations and non-prod testing environments within Zadara so your teams can validate performance, compatibility, and security before committing.",
  },
  {
    title: "Does Zadara support GPU-intensive applications?",
    content:
      "Absolutely. Zadara offers GPU-backed compute instances using NVIDIA hardware, ideal for AI/ML, rendering, and other intensive workloads. OneMind ensures these workloads are migrated with proper configuration and resource mapping.",
  },
  {
    title: "What happens if we need to roll back mid-migration?",
    content:
      "Rollback is built into our migration strategy. OneMind’s Xmost Migrator supports cold/warm rollback, and we maintain dual environments during critical phases to ensure zero disruption.",
  },
  {
    title: "Is our existing storage compatible with Zadara’s storage platform?",
    content:
      "Yes. Zadara supports block, file, and object protocols (iSCSI, NFS, S3, etc.), and OneMind maps existing storage configurations to Zadara’s zStorage with parity and minimal reformatting.",
  },
  {
    title: "Will we lose any VM metadata or security policies during migration?",
    content:
      "No. Our tooling preserves VM metadata, network configs, RBAC roles, and access policies. We validate everything during cutover with pre/post comparison scripts.",
  },
  {
    title: "Can we run a hybrid model (Zadara + VMware) during transition?",
    content:
      "Yes. OneMind enables co-existence between your current VMware environment and Zadara’s infrastructure, giving you flexibility during phased migrations or for long-term hybrid models.",
  },
  {
    title: "How does pricing work for Zadara? Are there upfront costs?",
    content:
      "Zadara uses a fully OPEX, usage-based model—no upfront hardware costs. You only pay for what you consume, and OneMind can help you model projected savings compared to VMware or public cloud.",
  },
  {
    title: "Where is Zadara hosted, and is it compliant with local regulations?",
    content:
      "Zadara operates in global edge locations and offers private hosted cloud zones. It supports regulatory requirements like GDPR, HIPAA, and SOC2, and OneMind ensures compliant architectures are part of your migration design.",
  },
];
